/**
 * ビルド時に注入される秘密鍵(tools/vite/secrets.ts)。
 *
 * バンドルに埋め込まれる前提であることを、参照側から見て明示するために
 * 独立したモジュールにしている。CLAUDE.md §9-6 の許容リスク。
 */
export const SECRET_CP: string = __SECRET_CP__;

/**
 * 達成証明コード用。圏外で証明を生成する必要があるため、参加者のバンドルにも入る。
 * 詳しくは src/lib/proof.ts の脅威モデル。
 */
export const SECRET_VERIFY: string = __SECRET_VERIFY__;
